<template>
  <div class="se-main">
    <iframe :src="url" width="100%" height="100%" border="0"></iframe>
    <div class="se-btn">
      <el-button type="danger" @click="downLoadFile">下载文件</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },

  created() {
    const type = this.$route.query.type;
    const typeList = ["ppt", "xlsx", "xls", "doc", "docx", "pptx"];
    if (typeList.includes(type)) {
      this.url = `https://view.officeapps.live.com/op/view.aspx?src=${JSON.parse(
        this.$route.query.url
      )}`;
    } else {
      this.url = JSON.parse(this.$route.query.url);
    }
  },

  methods: {
    downLoadFile() {
      const seUrl = JSON.parse(this.$route.query.url);
      const name = this.$route.query.name;
      // console.log(seUrl, "seUrl");
      this.openUrl(
        seUrl,
        `${name}.${seUrl.split(".")[seUrl.split(".").length - 1]}`
      );
    },

    openUrl(url, name) {
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const newUrl = window.URL.createObjectURL(x.response);
        // console.log("newUrl", newUrl);
        this.downLoad(newUrl, name);
      };
      x.send();
    },

    downLoad(file, name) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = file;
      // console.log(name);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.se-main {
  width: 100vw;
  height: 90vh;
}

.se-btn {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
}
</style>
